export default "__VITE_ASSET__DxIAWg_5__"